module.exports = __webpack_public_path__ + "img/arrow_right_2.23e24f9b.svg";